// src/pages/Work/MyUXProcess/MyUXProcess.js
import React from 'react';
import './MyUXProcess.css';

function MyUXProcess() {
  return (
    <div className="section-container">
      {/* Main heading and subtitle */}
      <h2 className="main-heading">
        My UX Process <span className="heading-subtitle">Approach</span>
      </h2>

      {/* Research Methods */}
      <h3 className="section-heading">Research Methods:</h3>
      <ul className="process-list">
        <li>
          Conducted in-depth user <strong>interviews</strong> to gather insights
        </li>
        <li>
          <strong>Benchmarking</strong> analysis
        </li>
        <li>
          Developed <strong>usability</strong> questions
        </li>
        <li>
          Created <strong>journey maps</strong>
        </li>
        <li>
          Wrote <strong>user stories</strong>
        </li>
        <li>
          Designed user <strong>personas</strong>
        </li>
        <li>
          Usability testing: <strong>A/B testing</strong>
        </li>
      </ul>

      {/* Design Techniques */}
      <h3 className="section-heading">Design Techniques:</h3>
      <ul className="process-list">
        <li>
          Figma - Developed <strong>wireframes</strong> and <strong>prototypes</strong> to iterate on design solutions.
        </li>
      </ul>

      {/* Testing */}
      <h3 className="section-heading">Testing:</h3>
      <ul className="process-list">
        <li>
          Performed <strong>usability testing</strong> sessions to gather feedback and iterate on designs.
        </li>
        <li>
          Collaborated with developers to <strong>implement responsive design</strong> solutions.
        </li>
      </ul>
    </div>
  );
}

export default MyUXProcess;